import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Badge,
  Collapse,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown,UncontrolledTooltip,

} from "reactstrap";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import {imageFileExtension,getImageFile} from "../../settings/shared/commonMethod"
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import RunService from '../../services/api/Run';
import UserService from '../../services/api/User';
import ChatService from '../../services/api/Chat';
import ProjectService from '../../services/api/Project'; 
import moment from 'moment'
import { SOCKET_API_BASE_URL } from '../../settings/shared/constants';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { Scrollbars } from 'react-custom-scrollbars';
import { CopyToClipboard } from "react-copy-to-clipboard";
import TinyURL from "tinyurl";
import { Launcher } from '../../components/Chat/';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';
import Avatar from 'react-avatar';
import { jobidLoad,projectLoad } from '../../components/Chat/UserInput';
import {uuidv4} from '../../components/Notebook/operations/notebook'

// import { projectLoad } from '../../components/Chat/UserInput';

const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }

}

class Chat extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      chatMsg: [],
      messages: [],
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      logDetails: [],
      open: true,
      jobname: '',
      description: '',
      modelInputFiles: [],
      modelCodeFiles: [],
      modelOutputFiles: [],
      modelOutputCodeFiles: [],
      parameterSet: '',
      runDBId: '',
      messageList: [],
      runId: '',
      jobIdLabel:'',
      jobIdName:'',
      pagehist:'',
      showDetails:false,
      setShowDetails :false,
      filter: true,
      chatrundata:[],
      chatrunFilterData:[],
      chatprojectdata:[],
      chatprojectdataFilterData:[],
      activeLink:'',
      badgeloading:false,
      openedCollapses: [""],
      projectDTOS:[],
      jobPageNumber:0,
      projectPageNumber:0,
      badgeloadingJob:false,
      badgeloadingProject:false,
      projectFlag:false,
      jobSearch:"",
      projectSearch:"",
      gettabvalue:"Runs",
      chatjobid:"",
      chatMasterIdentifier:"",
      chatprojectname:"",
      chattype:"",
      chatcount:"",
      chatrunDBId:"",
      cmaster:"",
      mastername:"",
      chatMasterId:"",
      chatName:"",
      chatrunDataForJobId:[],
      chatprojectDataForProject:[],
      jobIds:[],
      isMobile:'',
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      parametersTablesdata : []

    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }


  componentDidMount() {
    this.WebsocketInit();
    this.state.pagehist = localStorage.getItem("Pagehistory")
    // this.LoadrunsDetails('init');
    this.GetAllProject();
    this.GetAllProject_Init('notinit');
    const url = window.location.href

    this.state.ctype = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('ctype')
    this.state.chatMasterIdentifier = new URLSearchParams((url).substring(url.indexOf('&') + 1)).get('cid')  
  if(this.state.ctype === "Runs"){
      this.setState({gettabvalue:"Runs"})
      this.GetChatData();
      this.LoadrunsDetails('notinit');
      // this.Displaychattype(cid,this.state.ctype,totalUnreadMessager,crundbid,this.state.cmaster,this.state.mastername) 
    } 
   else if(this.state.ctype === "Project"){
      this.setState({gettabvalue:"Project"})
      this.GetChatData();
      this.LoadrunsDetails('notinit');
      // this.GetAllProject_Init('notinit');
    }
    else {
      this.LoadrunsDetails('init');
    }
    if(this.state.chatcount === "null"){
      this.state.chatcount = 0;
    }
    this.GetRunsData();

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
   }
   componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
   GetChatData = () =>{
    let size = 20;
     ChatService.GetChatIdentifierMessages(this.state.chatMasterIdentifier,localStorage.getItem("messagePageNumber"),size)
      .then((response) => {
        if(response !== ""){
          this.setState({
            chatjobid:response.jobId,
            chatMasterIdentifier: response.chatidentifier,
            chatName:response.chatName,
            chattype:this.state.ctype,
            chatcount:"0",
            chatrunDBId: response.sourceDBId,
            chatMasterId: response.chatMasterId,          
           },()=>{
             this.state.ctype === "Runs"?
             this.Displaychattype(this.state.chatjobid,this.state.ctype,this.state.chatcount,this.state.chatrunDBId,this.state.chatMasterId,this.state.chatName):
             this.Displaychattype(this.state.chatName,this.state.ctype,this.state.chatcount,this.state.chatrunDBId,this.state.chatMasterId,this.state.chatName)
            //  this.setState({activeLink:this.state.chatMasterId})
            })
            
          }
        else{
          // change this after api has become generic
           this.setState({activeLink:this.state.chatMasterId})
        }
      })
  }

  handleAddRow = () => {
    const item = {
      key: "",
      value: ""
    };
    this.setState({
      parametersTablesdata: [...this.state.parametersTablesdata, item]
    });
  };

  GetJobRun = (jobData) => {
    RunService.GetJobRun(jobData)
      .then((response) => {
        let parametersTables_array = []
        let parametersTables_files = response.parametersTables
        if (parametersTables_files !== null) {
          for (let index = 0; index < parametersTables_files.length; index++) {
            parametersTables_array.push(parametersTables_files[index])
          }
          this.setState({
            parametersTablesdata: parametersTables_array
          });
        }
        else{
          this.setState({
            parametersTablesdata: []
          });
        }
        this.setState({
          jobname: response.name,
          description: response.description,
          modelInputFiles: response.modelInputFiles,
          modelCodeFiles: response.modelCodeFiles,
          modelOutputFiles: response.modelOutputFiles,
          parameterSet: response.parameterSet,
          parametersTables: parametersTables_array,
          LogFiles: response.logEntries,
          runDBId: response.id,
          chatDbId: response.runId,
          modelOutputCodeFiles: response.modelOutputCodeFiles
        })
        //  if(this.state.chatDbId!=null){
        //   this.LoadChats(this.state.chatDbId);
        // }
        // this.LoadChats(response.id)
      })
  }

  onChangeRunId = (value) =>{
       if(value === ""){
         this.setState({
         chatrundata:this.state.chatrunFilterData,
         jobSearch:value
       })
       }else{
       const filteredUsers = this.state.chatrunFilterData.filter(item => item.sourceId.toString().toLowerCase().includes(value.toLowerCase())
       || item.chatName.toString().toLowerCase().includes(value.toLowerCase()));
       this.setState({
         chatrundata:filteredUsers,
          // loading: true
          jobSearch:value
       })
       } 
  }

  onChangeProjectName = (value) =>{
       if(value === ""){
         this.setState({
         chatprojectdata:this.state.chatprojectdataFilterData,
         projectSearch:value
       })
       }else{
       const filteredUsers = this.state.chatprojectdataFilterData.filter(item => item.chatName.toString().toLowerCase().includes(value.toLowerCase()));
       this.setState({
         chatprojectdata:filteredUsers,
          // loading: true
          projectSearch:value
       })
       }  
  }

  getProjectById = (id) =>{
    ProjectService.GetProjectById(id)
      .then((res) => {
        if (res.status === 'SUCCESS') {
          let response = res.projectDTOS;
          let parametersTables_array = []
          let parametersTables_files = response[0].parametersTables
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
          }
          this.setState({
            parametersTablesdata: parametersTables_array
          });
          this.setState({
          jobname: response[0].name,
          description: response[0].description,
          modelInputFiles: response[0].modelInputFiles,
          modelCodeFiles: response[0].modelCodeFiles,
          modelOutputFiles: response[0].modelOutputFiles,
          parameterSet: response[0].parameterSet,
          parametersTables: parametersTables_array,
          LogFiles: response[0].logEntries,
          runDBId: response[0].id,
          chatDbId: response[0].runId,
          modelOutputCodeFiles: response[0].modelOutputCodeFiles
        })
        }
      });
  }

  ChangeTab = (tabValue) => {
      if(tabValue === "Project"){
        this.setState({
          gettabvalue:"Project",
          projectSearch:"",
          jobIdLabel:"",
          messageList:[],
          projectFlag:true,
        },()=>{
           localStorage.setItem("messagePageNumber",0)
           this.state.gettabvalue === "Project" && this.state.chatprojectdata.length !== 0?this.Displaychattype(this.state.chatprojectdata[0].chatName,"project",this.state.chatprojectdata[0].totalUnreadMessages,this.state.chatprojectdata[0].sourceDBId,this.state.chatprojectdata[0].chatMasterId,this.state.chatprojectdata[0].chatName)  // To get messages by default job id on Init
           :console.log("tab changed")
          })
      }else{
        this.state.ctype = "";
        this.setState({
          gettabvalue:"Runs",
          jobPageNumber:0,
          jobIdLabel:"",
          jobIdName:"",
          messageList:[],
          projectFlag:false,
        },()=>{
           localStorage.setItem("messagePageNumber",0)
          this.state.chatrundata.length !== 0?
          this.Displaychattype(this.state.chatrundata[0].sourceId,"Runs",this.state.chatrundata[0].totalUnreadMessages,this.state.chatrundata[0].sourceDBId,this.state.chatrundata[0].chatMasterId,this.state.chatrundata[0].chatName):console.log("empty")  // To get messages by default job id on Init
        })
      }
  }


  handleScrollRuns = (e) =>{
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && this.state.jobSearch === "") {
      this.setState((preState) => {
        return {jobPageNumber : preState.jobPageNumber + 1};
      },()=>{
        this.LoadrunsDetails("notinit")
      });
    }
  }


  handleScrollProject = (e) =>{
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && this.state.projectSearch === "") {
      this.setState((preState) => {
        return {projectPageNumber : preState.projectPageNumber + 1};
      },()=>{
        this.GetAllProject_Init("notinit");
      });
    }
  }
    Displaychattype = (chatjobid,type,count,runDbId,chatmasterid,chatname) =>{
    if(count === "null"){
      count = 0
    }
    else{
      count = count
    }
    localStorage.setItem("scrollMount",true);  // set first time scroll mount
    localStorage.setItem("messagePageNumber",0);
    if(type === "Runs"){
     this.GetJobRun(chatjobid)
     if(count!=0){
        let readStatusPayload = {
            chatMasterId: chatmasterid,
            userId: localStorage.getItem('Uid')
          }
          RunService.ChatUpdateReadStatus(readStatusPayload).then((response) => {
            // here clear message count
            var pos = this.state.chatrundata.map(function(e) { return e.sourceId }).indexOf(parseInt(chatjobid));
            if(pos !== -1){
              this.state.chatrundata[pos].totalUnreadMessages = 0;
              this.state.chatrunFilterData[pos].totalUnreadMessages = 0;
            }
          });
      }
      this.setState({chatMasterId:chatmasterid,activeLink:chatmasterid,jobIdLabel:chatjobid,jobIdName:chatname},()=>{this.LoadMessagesByJobId(this.state.chatMasterId);})
  }else{
    let filterDBID = this.state.chatprojectdata.filter(item=>item.chatMasterId === chatmasterid)
    this.getProjectById(filterDBID[0].sourceDBId);
      if(count !== 0){
        let readStatusPayload = {
            chatMasterId: chatmasterid,
            userId: localStorage.getItem('Uid')
          }
          RunService.ChatUpdateReadStatus(readStatusPayload).then((response) => {
            // here clear message count
            var pos = this.state.chatprojectdata.map(function(e) { return e.chatName }).indexOf(chatjobid);
            if(pos !== -1){
              this.state.chatprojectdata[pos].totalUnreadMessages = 0;
              this.state.chatprojectdataFilterData[pos].totalUnreadMessages = 0;
            }
          });
      }
      this.setState({chatMasterId:chatmasterid,activeLink:chatmasterid,jobIdLabel: chatjobid,jobIdName:chatname},()=>{this.LoadMessagesByJobId(this.state.chatMasterId);})
    }
  }  

LoadMessagesByJobId = (chatmasterId) =>{
    this.setState( { 
      badgeloading:true,
      messageList: []
    } );
    let size = 20;
    // Get message page number from chatwindow scroll
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
      if(chatResponse==="" || chatResponse === ""){  // if chat response is 204 execure this condtion
            this.setState({
                messageList: [],
                // jobIdLabel: jobid,
                // runId:chatResponse.content[0].runDBId,
                badgeloading: false
            })
      }else{
        this.setState({
                messageList: chatResponse.chat.reverse(),
                // jobIdLabel: jobid,
                badgeloading: false
            })
      }
     });  
  }

  LoadOlderMessagesByJobId = (chatmasterId) =>{
    if (!this.state.socketLoadFlag) {
      this.setState({ badgeloading: true });
    }
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
        if(chatResponse==="" || chatResponse === ""){
          this.setState({
                messageList: this.state.messageList,
                // jobIdLabel: jobid,
                // runId:chatResponse.content[0].runDBId,
                badgeloading: false
          })
        }else{
          let chat = chatResponse.chat.reverse();
          if(chat.length === 0){
                this.setState({
                badgeloading: false
            })          
          }else{
              for(var i=0;i<chat.length;i++){
                this.setState({
                    messageList: [chat[i]].concat(this.state.messageList),
                    badgeloading: false
                })
              }
         }
        }  
     });  
  }

    LoadSocketMessage = (chatmasterId) =>{
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
        if(chatResponse==="" || chatResponse === ""){
          this.setState({
                messageList: this.state.messageList,
          })
        }else{
          let chat = chatResponse.chat.reverse();
            this.setState({
                messageList: [...this.state.messageList,chat[chat.length-1]],
            })
        }  
     });  
  }

  _onScrollLoadMessage(){
    if(localStorage.getItem("scrollMount")==='false' && localStorage.getItem("messagePageNumber") !== 0){
       this.LoadOlderMessagesByJobId(this.state.chatMasterId);
    }
  }

    
  _getJobById(jobId) {
    this.setState( { 
      loading:true,
    } );
    RunService.GetJobRun(jobId).then((response) => {
      let runDBId = response.id;
      RunService.GetChats(runDBId).then((chatResponse) => {
        this.setState({
          messageList: chatResponse,
          runId: runDBId,
          loading: false
        })
      });
    });
  }
  async _onMessageWasSent(message) {
    let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
    let chatPayload;
    let res = {
      "firstName": loggedInUser.firstName,
      "lastName": loggedInUser.lastName,
      "photoURL": null,
      "message": message.data,
      "createdDate": moment().format(),
    }

    if (message.files.length === 0) {  // Text message
      this.setState({
        messageList: [...this.state.messageList, res],
      })
      chatPayload = {
        "messageType": message.type,
        "message": message.data,
        "mentionedUsers": message.emails,
        "chatMasterId": this.state.chatMasterId
      }
      RunService.Postchat(chatPayload)
        .then((response) => { });

    } else { // media message
      res["mediaBase64Content"] = message.mediaBase64Content;
      this.setState({
        messageList: [...this.state.messageList, res],
      })
      chatPayload = {
        // "messageType": message.type,
        "message": message.data,
        // "mentionedUsers":message.emails,
        "chatMasterId": this.state.chatMasterId,
        "contentType": "application/png"
      }

      ChatService.PostMedia(chatPayload, message.files)
        .then((response) => { });
    }

    if (this.state.gettabvalue === "Project") {
      const from = this.state.chatprojectdata.findIndex(item => item.chatMasterId === chatPayload.chatMasterId); // find index of existing project Name
      this.state.chatprojectdata.splice(0, 0, this.state.chatprojectdata.splice(from, 1)[0]);
    } else {
      const from = this.state.chatrundata.findIndex(item => item.chatMasterId === chatPayload.chatMasterId); // find index of existing project Name
      this.state.chatrundata.splice(0, 0, this.state.chatrundata.splice(from, 1)[0]);
    }


    // this.setState({
    //   messageList: [...this.state.messageList, message]
    // })
  }

  async _sendMessage(text) {
    this.setState({
    badgeloading:true
  })
    if (text.length > 0) {
      this.setState({
        messageList: [...this.state.messageList, {
          author: 'them',
          type: 'text',
          data: { text }
        },
      ],
      badgeloading:false
      })
    }
  }
  //Init websocket for runs page
  WebsocketInit = () => {
    var _this = this;
    var socket = new SockJS(SOCKET_API_BASE_URL);
    var stompClient = Stomp.over(socket);
    stompClient.debug = null
    stompClient.connect('guest', 'guest', function (frame) {
      stompClient.subscribe('/topic/message' + localStorage.getItem("Uid"), function (notification) {
        //console.log(notification)
        let MyData = JSON.parse(notification.body);
       // console.log(JSON.stringify(MyData));
        if (MyData.notificationType === 'NOTIFICATION') {
          _this.setState({
            socketLoadFlag: true,
            loading: false,
            // jobPageNumber:0,
            // chatrundata:[],
            // chatrunFilterData:[],
          },()=>{
            // localStorage.setItem("messagePageNumber",0)
            // _this.LoadrunsDetails("notinit")
            var finalData = JSON.parse(MyData.message);
            if(finalData.chatMasterId === _this.state.chatMasterId){
              _this.LoadSocketMessage(_this.state.chatMasterId);
            }else{
              _this.RefreshNewMessage(finalData.chatMasterId);
            }
          })
        }
      })
    }, function (err) {
      // console.log('err', err);
      // _this.WebsocketInit();
    });
  }
  userselectedValue = (firstName, lastName) => {
    let myappendUser = firstName + " " + lastName + ", ";
    this.setState(prevState => ({ input: prevState.input.concat(myappendUser), showuserListFlag: false }))
  }

    RefreshNewMessage = (masterId) => {
     if(this.state.gettabvalue === "Project"){
       let filterDataNewMessage = this.state.chatprojectdataFilterData.filter(item=>item.chatMasterId === masterId)
       const index = this.state.chatprojectdataFilterData.findIndex(item => item.chatMasterId === masterId); // find index of existing project Name
        if (index !== undefined && filterDataNewMessage.length !== 0){
          this.state.chatprojectdata.splice(index, 1);  // If already have project name remove the project name and re-add the for avoid duplicates
          this.state.chatprojectdataFilterData.splice(index, 1);
            this.setState({chatprojectdata: [filterDataNewMessage[0]].concat(this.state.chatprojectdata),
            chatprojectdataFilterData: [filterDataNewMessage[0]].concat(this.state.chatprojectdataFilterData)},()=>{
              this.UpdateChatCountNewMessage(masterId,this.state.gettabvalue); // Update chat count offline
            })
        }
     }else{
       let filterDataNewMessageJOb = this.state.chatrunFilterData.filter(item=>item.chatMasterId === masterId)
       const index = this.state.chatrunFilterData.findIndex(item => item.chatMasterId === masterId); // find index of existing project Name
       if (index !== undefined && filterDataNewMessageJOb.length !== 0){
          this.state.chatrundata.splice(index, 1);  // If already have project name remove the project name and re-add the for avoid duplicates
          this.state.chatrunFilterData.splice(index, 1);
            this.setState({chatrundata: [filterDataNewMessageJOb[0]].concat(this.state.chatrundata),
            chatrunFilterData: [filterDataNewMessageJOb[0]].concat(this.state.chatrunFilterData)},()=>{
              this.UpdateChatCountNewMessage(masterId,this.state.gettabvalue); // Update chat count offline
            })
        }
     }
  }

  UpdateChatCountNewMessage = (masterId,activeTab) =>{
      if(activeTab === "Project"){
        this.state.chatprojectdata.some(function(obj){
          if (obj.chatMasterId === masterId){
                //change the value here
                 obj.totalUnreadMessages += 1
                return true;    //breaks out of he loop
          }
        });
        this.setState({
          chatprojectdata:this.state.chatprojectdata,
          chatprojectdataFilterData:this.state.chatprojectdata
        })

     }else{
          this.state.chatrundata.some(function(obj){
          if (obj.chatMasterId === masterId){
                //change the value here
                 obj.totalUnreadMessages += 1
                return true;    //breaks out of he loop
          }
        });
        this.setState({
          chatrundata:this.state.chatrundata,
          chatrunFilterData:this.state.chatrundata
        })
      }
  }

  keyPressed = (event) => {
    if (event.keyCode === 13) {
      this.submitMessage()
    } else if (event.keyCode === 50) {
      this.setState({ showuserListFlag: true });
    } else {
      this.setState({ showuserListFlag: false });
    }
  }

  GetAllProject = () =>{
      ProjectService.GetProject(0,50)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let responseData = response.projectDTOSPage;
          if (responseData.content !== null) {
          this.setState({
            projectDTOS:responseData.content
          },()=>{
            projectLoad(this.state.projectDTOS);  // store project names for chat # features
          });
        }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  GetAllProject_Init(loadType){
    if (!this.state.socketLoadFlag) {
      this.setState({ badgeloadingProject: true });
    }
      let size = 20;
      ChatService.GetChatProject(this.state.projectPageNumber,size)
      .then((response) => {
        if(response !== ""){
          response.chatItems.map((item,index) => {
            this.setState({
              chatprojectDataForProject:[...this.state.chatprojectDataForProject,item],
            })
          // if(item.totalMessages!=0){
            if(item.totalUnreadMessages === 0){
              this.setState({
                chatprojectdata: [...this.state.chatprojectdata,item],
                chatprojectdataFilterData: [...this.state.chatprojectdataFilterData,item]
              })
            }else{
              this.setState({chatprojectdata: [item].concat(this.state.chatprojectdata),
              chatprojectdataFilterData: [item].concat(this.state.chatprojectdataFilterData)})
            }
          // }
        });
        this.setState({badgeloadingProject:false})
        if(loadType === "init"){
                this.Displaychattype(this.state.chatprojectdata[0].chatName,"project",this.state.chatprojectdata[0].totalUnreadMessages,this.state.chatprojectdata[0].sourceDBId,this.state.chatprojectdata[0].chatMasterId,this.state.chatprojectdata[0].chatName)  // To get messages by default job id on Init
          }else{
            console.log("");
            // this.setState({ loading: false });
          }
        }else{
          this.setState({badgeloadingProject:false})
          // console.log("scroll end");
        }
      })
   }

   GetRunsData = () => {
    let postData = {
      projectId: null
    }
      // RunService.getRunbySize(postData,0,2)
      // .then((res) => {
      //   if(res!=""){
      //       let size = res.runDetails.totalElements;
            RunService.getRunbySize(postData,0,10).then((response) => {
              if(response !== ""){
                if (response.status === 'SUCCESS') {
                  let runSDTO = response.runDetails.content;
                  // this.renderData(runSDTO);
                  // jobidLoad(runSDTO);
                  this.setState({
                    jobIds:runSDTO
                  },()=>{
                    this.state.jobIds.length !== 0?jobidLoad(this.state.jobIds):jobidLoad([]);
                  })
                } else {
                  toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                }
              }else{
                console.log("")
              }
            });  
        //     }else{
        //   console.log("end scroll")
        // }
      // })
  }

  LoadrunsDetails = (loadType) =>{
    if (!this.state.socketLoadFlag) {
      this.setState({ badgeloadingJob: true });
    }
      let size = 20;
      ChatService.GetChatRunIds(this.state.jobPageNumber,size)
      .then((response) => {
        if(response !== ""){  // if chat response is 204 execure this condtion
          response.chatItems.map((item,index) => {
            this.setState({
            chatrunDataForJobId:[...this.state.chatrunDataForJobId,item],
          })
          // if(item.totalMessages!=0){
            if(item.totalUnreadMessages === 0){
              this.setState({
                chatrundata: [...this.state.chatrundata,item],
                chatrunFilterData: [...this.state.chatrunFilterData,item]
              })
              }else{
                this.setState({chatrundata: [item].concat(this.state.chatrundata),
                chatrunFilterData: [item].concat(this.state.chatrunFilterData)})
              }          
        // }
      });
      // if(this.state.chatrundata.length<12 && response.totalPages!=this.state.jobPageNumber){
      //       this.setState((preState) => {
      //         return {jobPageNumber : preState.jobPageNumber + 1};
      //       },()=>{
      //         // this.scrollList.scrollToTop();
      //         this.LoadrunsDetails("init")
      //       });
      //   }else{
          this.setState({badgeloadingJob:false})
          // jobidLoad(this.state.chatrunDataForJobId);  // store job id's for chat ## features
            if(loadType === "init"){
            // || localStorage.getItem("navigateJobId")!=null
            // if(localStorage.getItem("navigateJobId")!=null){
            //       let jobid = localStorage.getItem("navigateJobId");
            //       localStorage.removeItem("navigateJobId");
            //       let filterData = this.state.chatrundata.filter(item=>item.sourceId==jobid)

                  // this.Displaychattype(jobid,"Runs",filterData.totalUnreadMessages,filterData.sourceDBId,filterData.id,filterData.chatName)  // To get messages by default job id on Init
                //   this.Displaychattype(jobid,"Runs",filterData.totalUnreadMessages,filterData.sourceDBId,this.state.chatMasterId,filterData.chatName)  // To get messages by default job id on Init

                // }else{
                // console.log(this.state.chatrundata)
                this.state.chatrundata.length !== 0?
                this.Displaychattype(this.state.chatrundata[0].sourceId,"Runs",this.state.chatrundata[0].totalUnreadMessages,this.state.chatrundata[0].sourceDBId,this.state.chatrundata[0].chatMasterId,this.state.chatrundata[0].chatName):console.log("empty")  // To get messages by default job id on Init
              // }   
          }else{
            console.log("");
            // this.setState({ loading: false });
          }
        // }
        }else{
          this.setState({badgeloadingJob:false})
          // console.log("end scroll")
        }
      })
  }

  submitMessage = () => {
    this.setState(
      {
        messages: [...this.state.messages, this.state.input],
        input: ""
      }
    );
    let chatPaylad = {
      "runDBId": this.state.runDBId,
      "message": this.state.input
    }
    RunService.Postchat(chatPaylad)
      .then((response) => {
      })
  }

  clearMessages = () => {
    this.setState({ messages: [] });
  }

  // Load all chats for particular run id
  //  LoadChats = (rundbId) => {
    LoadChats(rundbId) {
    this.setState( { 
      loading:true,
    } );

    let profile = JSON.parse(localStorage.getItem("UserProfile"));
    this.setState({
      localName: profile.firstName + " " + profile.lastName,
      localPhoto: profile.photoURL,
      input: '',
      messages: []
    });
    RunService.GetChats(rundbId)
      .then((response) => {
        this.state.countitem = response.length;
        this.setState({
          chatMsg: response,
          loading:false
        })
     
        let uId = localStorage.getItem("Uid");
        this.GetAllUsers(uId);
      })
  }
  GetAllUsers = (allid) => {
    let uid = {
      id: allid
    }
    UserService.getAllUsers(this.state.usersid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.setState({
            UserList: response.userDTOS
          });
        } else {
          // console.log(response.errorMessage);
        }
      })
  }
  handleChange = (event) => {
    this.setState({ input: event.target.value });
  }
  OpenStorageView = (name, event) => {
    event.preventDefault()
    let currentUrlp = window.location.href;
    let regd = "/chat";
    let redirectUrl = currentUrlp.replace(regd, "/storageView?file="+name);
    window.open(redirectUrl, "_blank");
   }

  copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 
  }
  
  GetLink = (name,event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/chat";
    let redirectUrl = currentUrl.replace(reg, "/storageView?file="+name);
  
    TinyURL.shorten(redirectUrl).then((res) =>{
      this.ShareURL(res, name);
    })
  }

  ShareURL = (tinylink, fileName) => {
    this.setState({ gettinylink: tinylink });
    this.state.copylink = tinylink;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='content'>
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <Row >
                      <div className="col">
                      <h6><i className="fas fa-link"></i>&nbsp; Get Link </h6>
                      </div>
                      <div className="col text-right">
                        <div>
                          <span className="close clear-filter" style={{ cursor: "pointer" }} onClick={() => { onClose() }}>×</span>
                        </div>

                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md="8">

                        <FormGroup>
                          <Input className="form-control-alternative" style={{ width: '260px' }} value={this.state.copylink}
                            onChange={({ target: { value } }) => this.setState({ value, copied: false })} />

                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <CopyToClipboard text={this.state.copylink}
                            onCopy={() => this.setState({ copied: true })}>
                            <p style={{ cursor: "pointer" }} onClick={this.copyAlert}><b>Copy Link</b></p>
                          </CopyToClipboard>
                        </FormGroup>
                      </Col>

                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>

        )
      }
    });
  }
  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    RunService.downloadFile(fileName, rid, type)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([JSON.stringify(response)]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();// you need to remove that elelment which is cre
      })
  }
  
  showdetails = () => {
    this.state.projdetails = false;
    this.setState({projdetails:true})
  }

  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== 'undefined') {
        // filter by text in the table or if it's a object, filter by key
        if (typeof content === 'object' && content !== null && content.key) {
            return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
        } else {
            return String(content).toLowerCase().includes(filter.value.toLowerCase());
        }
    }

    return true;
};

collapsesToggle = collapse => {
  let openedCollapses = this.state.openedCollapses;
  if (openedCollapses.includes(collapse)) {
    this.setState({
      openedCollapses: []
    });
  } else {
    this.setState({
      openedCollapses: [collapse]
    });
  }
};

handleClick = (e) => {
  e.preventDefault();
    if(e.type === "contextmenu") {
      var arrt = e.currentTarget.getAttribute("data_attr_id");
      document.getElementById(arrt).click();
  }  
}

  render() {
    const { open } = this.state;
    return (
    
        <>
          <PanelHeader
            content={
              <div className="header text-center">
              </div>
            }
          />
          <div className="content">
          <LoadingOverlay
        active={this.state.loading}
        spinner={<ScaleLoader
          height={35}
          width={5}
          radius={2}
          margin={2}
          color={"#123abc"}
          loading={this.state.loading}
        />}>
            <div className="row" >

              <div className="card h-100">
                <Card style={{marginBottom: '0px' }}>
                  <CardBody style={{padding:"15px 15px 0px 15px"}}>
                  <div className="carcontent">

                  <div className="row no-gutters">
                    <Col xs={12} sm={12} >
                    <Row style={{ backgroundColor: '#f2f2f2'}}>
                     <Col xs={12} sm={3} className="chatsidebar" >
                       <Tabs defaultTab={this.state.gettabvalue} onChange={tabId => this.ChangeTab(tabId)}>
                           <TabList>
                              <Row style={{ backgroundColor: '#f2f2f2'}}>
                                 <div className="col">
                                     <Tab tabFor="Runs" className="adddatatab">&nbsp; &nbsp; Runs &nbsp; &nbsp;</Tab>
                                     <Tab tabFor="Project" className="adddatatab"> &nbsp; Projects &nbsp; &nbsp;</Tab>
                                  </div>
                                </Row>
                              </TabList>
                              <TabPanel tabId="Runs">
                                 <CardBody>
                                 <div className="chattable"> 
                                     <form>
                                          <InputGroup className="no-border" style={{ border: "1px solid #d3d3d3" }}>
                                            <Input placeholder="Search..." onChange={event => this.onChangeRunId(event.target.value)}
                                              value={this.state.jobSearch} style={{ color: 'black', height: '30px', fontSize: '14px', backgroundColor: '#fff' }} />

                                            <InputGroupAddon addonType="append" style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                                              <InputGroupText style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                                                &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                                              </InputGroupText>
                                            </InputGroupAddon>
                                          </InputGroup>
                                        </form>
                            
                            <Scrollbars autoHeight autoHeightMin={this.state.sheight-220} ref='scrollbar' 
                            renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                            onScroll={this.handleScrollRuns} style={{marginLeft:"10px"}}>
                                     {/*chat data place here*/}
                                     {/*<FlipMove typeName="ul" style={{ color: 'red'}}>
                                       
                                       {this.state.chatrundata.map(article => (
                                         <li key={article.jobId}>{article.jobId}</li>
                                      ))}
                                    </FlipMove>*/}
                                    <UncontrolledDropdown direction="right">
                                     {this.state.chatrundata.map((item,index) => (
                                      <div style={{paddingTop: 5}} key={item.chatMasterId}>
                                      {/*{(item.chatDOS.length != 0) &&  */}
                                      <div className={item.totalUnreadMessages !== 0?"messageCountback":"" }><DropdownItem key={item.chatMasterId}
                                      href="" style={{cursor: "pointer"}}  id={item.chatMasterId} className={item.chatMasterId === this.state.activeLink ?"chatRun activeBack":"chatRun" }  onClick={e=>this.Displaychattype(item.sourceId,'Runs',item.totalUnreadMessages,item.sourceDBId,item.chatMasterId,item.chatName)}>
                                    <span title={item.chatName} className={item.totalUnreadMessages !== 0?"chatuUnreadCount":""}> 
                                    <Row style={{paddingLeft: 12}} xs="12">
                                      <Col xs="2">
                                     {item.sourceId}
                                     </Col>
                                      <Col xs="8">
                                     <span className="overflowStyle">{item.chatName}</span>
                                     </Col>
                                     <Col xs="2">
                                     {item.totalUnreadMessages !== 0 &&<span className="chatcount__badge">{item.totalUnreadMessages}</span>}
                                     </Col>
                                     </Row>
                                    </span>
                                    </DropdownItem>
                                    </div>
                                    {/*}*/}
                                    </div>   
                                  ))} 

                                  {this.state.chatrundata.length === 0 && 
                                    <div className="df-text-black-50 text-center">
                                      <span>No Runs Found </span>
                                    </div>
                                  }
                                  </UncontrolledDropdown>
                                  { this.state.badgeloadingJob === true &&  <div className="chatLoading text-center">
                                  <Badge color="info" >Loading...</Badge>
                                  </div>}
                                  </Scrollbars>   
                                  </div> 
                                </CardBody>
                                </TabPanel>
                              <TabPanel tabId="Project">
                                      <CardBody>
                    
                                      <div className="chattable"> 
                                        <form>
                              <InputGroup className="no-border" style={{border: "1px solid #d3d3d3"}}>
                              <Input placeholder="Search..." onChange={event => this.onChangeProjectName(event.target.value)}
                                  value={this.state.projectSearch} style={{color: 'black',height:'30px',fontSize:'14px',backgroundColor:'#fff' }}/>
              
                              <InputGroupAddon addonType="append" style={{backgroundColor:'#fff', borderRadius:'5px',height: '30px'}}>
                                <InputGroupText style={{backgroundColor:'#fff', borderRadius:'5px',height: '30px'}}>
                                 &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                            </form>
                            <Scrollbars autoHeight autoHeightMin={this.state.sheight-220} ref='scrollbar' 
                            renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                            onScroll={this.handleScrollProject} style={{marginLeft:"10px"}}>
                              <UncontrolledDropdown direction="right">
                                     {this.state.chatprojectdata.map((item,index) => (<DropdownItem key={item.chatMasterId}
                                    href="" style={{cursor: "pointer"}} id={item.chatMasterId} className={item.chatMasterId === this.state.activeLink ?"chatRun activeBack":"chatRun" }  onClick={e=>this.Displaychattype(item.chatName,'project',item.totalUnreadMessages,item.sourceDBId,item.chatMasterId,item.chatName)}>
                                  <Row xs="12">
                                  <Col xs="2">
                                      <Avatar round={true} color={Avatar.getRandomColor('sitebase', ['violet', 'coral', '#851fc4','sandybrown'])}
                                      name= {item.chatName} size="35" />
                                  </Col>
                                  <Col xs="8">
                                    <span title={item.chatName} className="overflowStyle" style={{marginTop: 10,marginLeft: 10}}>{item.chatName}</span>
                                  </Col>
                                  <Col xs="2">
                                    <span className={item.totalUnreadMessages !== 0?"chatuUnreadCount":""}> 
                                     {item.totalUnreadMessages !== 0 &&<span className="chatcount__badge margin">{item.totalUnreadMessages}</span>}
                                    </span>
                                  </Col>
                                </Row>
                                  {/*<Row>
                                  <Col>
                                  <span title={item.chatName}> 
                                    <Avatar round={true} color={Avatar.getRandomColor('sitebase', ['violet', 'coral', '#851fc4','sandybrown'])}
                                    name= {item.chatName} size="35" /> &nbsp; <span className="overflowStyle">{item.chatName}</span>
                                  </span>
                                  </Col>
                                  <Col>
                                  <span className={item.totalUnreadMessages!=0?"chatuUnreadCount":""}> 
                                     {item.totalUnreadMessages!=0 &&<span className="chatcount__badge">{item.totalUnreadMessages}</span>}
                                    </span>
                                  </Col>
                                  </Row>*/}
                                  </DropdownItem>
                                  ))} 
                                   {this.state.chatprojectdata.length === 0 && 
                                    <div className="df-text-black-50 text-center">
                                      <span>No Projects Found </span>
                                    </div>
                                  }
                                  </UncontrolledDropdown>
                                  { this.state.badgeloadingProject === true &&  <div className="chatLoading text-center">
                                  <Badge color="info" >Loading...</Badge>
                                  </div>}
                            </Scrollbars>      
                   </div> 
                  
                                       </CardBody>
                                  </TabPanel>
                      </Tabs>

                    </Col>
                     <Col xs={12} sm={this.state.showDetails ? "6" : "9"} className="chatcenter">
                     <CardHeader style={{height: '40px', padding: '7px 0px 0px 10px'}}>
                       <Row className="align-items-center">
                       <div className="col">
                          {!this.state.projectFlag && this.state.chatrundata > 0 && <div className="chatheadertext">Run: {this.state.jobIdLabel} - &nbsp;{this.state.jobIdName}</div> } 
                          {this.state.projectFlag && this.state.chatprojectdata > 0 && <div className="chatheadertext">Project Name:&nbsp;{this.state.jobIdName}</div> }  
                       </div>
                         <div className="col text-right">
                         <i className="fas fa-info-circle" style={{fontSize:'20px',cursor: "pointer"}} id="showrun" onClick={() => this.setState({ showDetails: !this.state.showDetails}) }></i> &nbsp; &nbsp;
                        </div>
                        <UncontrolledTooltip placement="bottom" target="showrun" delay={0}>
                        {this.state.showDetails ? "Hide" : "Show"} Run Details
                        </UncontrolledTooltip>
                      </Row>
                    </CardHeader>
                    <p>{this.state.messagetxt}</p>
                    { this.state.badgeloading === true &&  <div className="chatLoading text-center">
       <Badge color="info" >Loading...</Badge>
       </div>}

                    { (this.state.badgeloading === false &&  this.state.messageList.length === 0) && <div style={{textAlign:"center",marginTop:"100px"}}>
                      <span>No Comments </span></div>}
              
                      {((this.state.chatrundata.length !==0 && this.state.gettabvalue === "Runs") || 
                      (this.state.chatprojectdata.length !==0 && this.state.gettabvalue === "Project")) && <Launcher
                          agentProfile={{
                          }}
                          onMessageWasSent={this._onMessageWasSent.bind(this)}
                          messageList={this.state.messageList}
                          _onScrollLoadMessage={this._onScrollLoadMessage.bind(this)}
                          showEmoji
                        />}
                      </Col>
                     <Col xs={12} sm={3} className="chatRight">
                      <div>
                        {this.state.showDetails && <div>
                          <Row >
                      <div className="col">
                      <h5 className="title">Run Details </h5>
                      </div>
                      <div className="col text-right">
                        <div>
                        <i className="far fa-times-circle" style={{fontSize:'18px',cursor: "pointer"}} onClick={() => this.setState({ showDetails: !this.state.showDetails}) }></i>
                        </div>

                      </div>
                    </Row>
                  {/* <Scrollbars autoHeight autoHeightMin={680} autoHeightMax={680} thumbMinSize={30} > */}

          <Card className="card-user">
             <CardBody>
             <Scrollbars autoHeight autoHeightMin={this.state.sheight-220} autoHeightMax={this.state.sheight-220} thumbMinSize={30} >

                  <div className="chatdesp">
                    <a href="#" onClick={e => e.preventDefault()}>
                    <div><Avatar round={true} color={Avatar.getRandomColor('sitebase', ['violet', 'coral', '#851fc4','sandybrown'])} className="avatar border-gray" name= {this.state.jobname} size="50" 
                          />
                    </div>
                    <h5 className="title"> {this.state.jobname}</h5>
                    </a>
                    <p className="description"> {this.state.description}</p>
                  </div>
                  <div
                    aria-multiselectable={true}
                    className="card-collapse"
                    id="accordion"
                    role="tablist"
                  >
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseOne"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseOne");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Input Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseOne"
                        )}
                      >
                        <CardBody>
                        {this.state.modelInputFiles !== null && this.state.modelInputFiles.map((item,index) => (
                          <div className="chatdespul" key={uuidv4()} >
                          <ul>
                            <li className="listyle">
                                    <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"j"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a className="text-primary" style={styles.chaticon}><u
                                                style={{fontSize:'13px'}}>{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"j"}>
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                           </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span>
                                              <i className="fas fa-download mr-2" /> Download
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
                                    </li>
                                    </ul>
                                  
                          </div>
                          ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseTwo"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseTwo");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Code Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseTwo"
                        )}
                      >
                        <CardBody>
                        {this.state.modelCodeFiles !== null && this.state.modelCodeFiles.map((item,index) => (
                            <div className="chatdespul" key={uuidv4()} >
                              <ul>
                                <li className="listyle">
                                   <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"k"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a className="text-primary" style={styles.chaticon}><u
                                                style={{fontSize:'13px'}}>{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"k"}>
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                            </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span >
                                              <i className="fas fa-download mr-2" /> Download
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
</li>
</ul>
</div>
                                  ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseThree"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseThree");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Output Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseThree"
                        )}
                      >
                        <CardBody>
                        {this.state.modelOutputFiles !== null && this.state.modelOutputFiles.map((item,index) => (
                                  <div className="chatdespul" key={uuidv4()} >
                                  <ul>
                                    <li className="listyle">
                                 <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"l"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a className="text-primary" style={styles.chaticon}><u
                                                style={{fontSize:'13px'}}>{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"l"}> 
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span >
                                              <i className="fas fa-download mr-2" /> Download
                                            </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
</li>
</ul>
</div>

                                  ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseFour"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseFour");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Output Code Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseFour"
                        )}
                      >
                        <CardBody>
                        {this.state.modelOutputCodeFiles !== null && this.state.modelOutputCodeFiles.map((item,index) => (
                                   <div className="chatdespul" key={uuidv4()} >
                                   <ul>
                                     <li className="listyle">
                                  <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"m"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a className="text-primary" style={styles.chaticon}><u
                                                style={{fontSize:'13px'}}>{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"m"}>
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span >
                                              <i className="fas fa-download mr-2" /> Download
                                            </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
</li>
</ul>
</div>
                                  ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseFive"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseFive");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Business Levers</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseFive"
                        )}
                      >
                        <CardBody>
                        <Scrollbars autoHeight >
                        {this.state.parametersTablesdata.length > 0 &&
                        <div>
                        <Table responsive className="table-hover paratbl"
                          id="tab_logic"
                        >
                          <thead>
                            <tr>
                              <th>Variables </th>
                              <th style={{ width: "80%" }}> Values </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.parametersTablesdata.map((item, index) => (
                              item.row !== false &&
                              <tr id="addr0" key={index}>
                                <td className="variabletxt">{item.key}</td>
                                <td style={{ width: "80%" }}>
                                  <Input
                                    className="form-control-alternative valuetxt"
                                    defaultValue={item.value}
                                    style={{ border: 'none', borderRadius: '5px' }}
                                    id={uuidv4()} 
                                    name="parameterSet"
                                    disabled
                                    type="text"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        </div>
                        }
                          {this.state.parametersTablesdata.length === 0 && <span style={{color: 'darkgray', fontSize: '14px'}}>  &nbsp; No Business Levers Found</span>}

                                    {/* <div>{this.state.parameterSet != null && <p style={{ marginLeft: 5, fontSize: "0.80rem", marginBottom: 5, lineHeight: 2 }}>
                                      {
                                        this.state.parameterSet.split("\n").map((i, key) => {
                                          return <div style={{ whiteSpace: 'nowrap' }} key={uuidv4()} >{i}</div>;
                                        })}
                                    </p>}</div> */}
                                  </Scrollbars>
                        </CardBody>
                      </Collapse>
                    </Card>
               
               </div>
               </Scrollbars>
                </CardBody>
                </Card>
                              {/* </Scrollbars> */}
                          </div>
                        }
                        </div>
                          </Col>  
                    </Row>
                      </Col>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
            </LoadingOverlay>

          </div>
        </>
    );
  }
}

export default Chat;
